import axios from 'axios'
import { browserName, osName } from 'react-device-detect'

const EndPoints = {
  SendEmailToken: 'v2/sonar/token/email',
  ValidEmailToken: 'v2/sonar/token/email/validate',
  SendSMSToken: 'v2/sonar/token/phone',
  ValidSMSToken: 'v2/sonar/token/phone/validate',
  passwordValidate: 'v1/api/participant/password/validate',
  postLog: 'v1/api/status/verify',
  searchCPF: 'v1/api/participant',
  resendPassword: 'v1/api/participant/ResendInvitation',
  checkWhiteList: 'v1/api/participant/verify',
  checkCaptcha: 'login/check',
  saveCaptcha: '/api/recaptcha/saveToken',
  uraPasswordExists: 'v1/api/ura/exists',
  createUraPassword: 'v1/api/ura/create/passwordnumber',
  passwprojectIdordValidate: 'v1/api/signup/passwordnumber/validate',
  passwordValidateLegacy: 'v1/api/ura/legacy/passwordnumber/validate'
}
const BaseURL = process.env.RAZZLE_ONBOARDING_API_BASEURL
const BaseWithoutApiMan = process.env.ONBOARDING_DIRECT_BASEURL
const campaingId = Buffer.from(process.env.RAZZLE_CAMPAIGN_ID).toString('base64')
let token = typeof window !== 'undefined' && window.localStorage.getItem('token_auth')
let geoLocation = null

export const OnboardingService = {
  getGeolocation() {
    return geoLocation
  },
  async SetGeolocation(location) {
    geoLocation = {
      date: new Date(location.timestamp),
      coords: {
        altitude: location.coords.altitude,
        latitude: location.coords.latitude,
        longitude: location.coords.longitude,
        accuracy: location.coords.accuracy
      }
    }
  },
  async SetGeolocationError(error) {
    geoLocation = error
  },
  async SendEmailToken(form) {
    const {
      data: { data }
    } = await axios({
      url: `${BaseURL}/${EndPoints.SendEmailToken}`,
      method: 'POST',
      data: form,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        'Ocp-Apim-Trace': true,
        Authorization: `Bearer ${token}`,
        ProjectId: campaingId,
        Geolocation: JSON.stringify(geoLocation)
      }
    })
    return data
  },
  async ValidEmailToken(form) {
    const {
      data: { data }
    } = await axios({
      url: `${BaseURL}/${EndPoints.ValidEmailToken}`,
      method: 'POST',
      data: form,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        'Ocp-Apim-Trace': true,
        Authorization: `Bearer ${token}`,
        ProjectId: campaingId,
        Geolocation: JSON.stringify(geoLocation)
      }
    })
    return data
  },
  async SendSMSToken(form) {
    const {
      data: { data }
    } = await axios({
      url: `${BaseURL}/${EndPoints.SendSMSToken}`,
      method: 'POST',
      data: form,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        'Ocp-Apim-Trace': true,
        Authorization: `Bearer ${token}`,
        ProjectId: campaingId,
        Geolocation: JSON.stringify(geoLocation)
      }
    })
    return data
  },
  async ValidSMSToken(form) {
    const {
      data: { data }
    } = await axios({
      url: `${BaseURL}/${EndPoints.ValidSMSToken}`,
      method: 'POST',
      data: form,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        'Ocp-Apim-Trace': true,
        Authorization: `Bearer ${token}`,
        ProjectId: campaingId,
        Geolocation: JSON.stringify(geoLocation)
      }
    })
    return data
  },
  async ValidPasswordNumber(form) {
    const {
      data: { data }
    } = await axios({
      url: `${BaseURL}/${EndPoints.passwprojectIdordValidate}`,
      method: 'POST',
      data: form,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        'Ocp-Apim-Trace': true,
        Authorization: `Bearer ${token}`,
        Geolocation: JSON.stringify(geoLocation)
      }
    })
    return data
  },
  async PostLog(form) {
    form['BrowserName'] = browserName
    form['OSName'] = osName
    form['Source'] = `${process.env.RAZZLE_GRAYLOG_SOURCE}`
    const {
      data: { data }
    } = await axios({
      url: `${BaseURL}/${EndPoints.postLog}`,
      method: 'POST',
      data: typeof window !== 'undefined' && window.btoa(JSON.stringify(form)),
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        'Ocp-Apim-Trace': true,
        ProjectId: campaingId,
        Geolocation: JSON.stringify(geoLocation)
      }
    })
    return data
  },
  async SearchCPF(cpf) {
    try {
      const {
        data: { data }
      } = await axios({
        url: `${BaseURL}/${EndPoints.searchCPF}`,
        method: 'POST',
        data: {
          projectId: parseInt(process.env.RAZZLE_CAMPAIGN_ID),
          encodedDocumentNumber: cpf
        },
        headers: {
          'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
          'Ocp-Apim-Trace': true,
          Authorization: `Bearer ${token}`,
          Geolocation: JSON.stringify(geoLocation)
        }
      })
      return data
    } catch (e) {
      return false
    }

  },
  async ResendPassword(cpf) {
    const {
      data: { data }
    } = await axios({
      url: `${BaseURL}/${EndPoints.resendPassword}`,
      method: 'POST',
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        Geolocation: JSON.stringify(geoLocation)
      },
      data: {
        documentNumber: cpf,
        projectId: process.env.RAZZLE_CAMPAIGN_ID
      }
    })
    return data
  },
  async CheckWhiteList(cpf) {
    const cpfEncoded = Buffer.from(cpf).toString('base64')
    const {
      data: { data }
    } = await axios({
      url: `${BaseURL}/${EndPoints.checkWhiteList}`,
      method: 'POST',
      data: {
        projectId: parseInt(process.env.RAZZLE_CAMPAIGN_ID),
        encodedDocumentNumber: cpfEncoded
      },
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        Geolocation: JSON.stringify(geoLocation)
      }
    })
    return data
  },
  async CheckCaptcha(cpf) {
    try {
      const cpfEncoded = Buffer.from(cpf).toString('base64')
      const {
        data: { data }
      } = await axios({
        url: `${EndPoints.checkCaptcha}/${cpfEncoded}`,
        method: 'GET',
        headers: {
          'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
          Geolocation: JSON.stringify(geoLocation),
          ProjectId: campaingId
        }
      })
      return data
    } catch (error) {
      return false
    }
  },
  async SaveCaptcha(cpf, token) {
    const {
      data: { data }
    } = await axios({
      url: `${BaseWithoutApiMan}/${EndPoints.saveCaptcha}`,
      method: 'POST',
      data: {
        DocumentNumber: cpf,
        Token: token
      },
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        ProjectId: campaingId
      }
    })
    return data
  },
  async UraPasswordExists(username) {
    const usernameEncoded = Buffer.from(username).toString('base64')
    const {
      data: { data }
    } = await axios({
      url: `${BaseURL}/${EndPoints.uraPasswordExists}/${usernameEncoded}`,
      method: 'GET',
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        ProjectId: campaingId
      }
    })
    return data
  },
  async ValidPasswordNumberLegacy(form) {
    const {
      data: { data }
    } = await axios({
      url: `${BaseURL}/${EndPoints.passwordValidateLegacy}`,
      method: 'POST',
      data: form,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
        'Ocp-Apim-Trace': true,
        ProjectId: campaingId,
        Geolocation: JSON.stringify(geoLocation)
      }
    })
    return data
  },
  async CreateUraPassword(token, form) {
    try {
      const {
        data: { data }
      } = await axios({
        url: `${BaseURL}/${EndPoints.createUraPassword}`,
        method: 'POST',
        data: form,
        headers: {
          'Ocp-Apim-Subscription-Key': process.env.RAZZLE_ONBOARDING_SUBSCRIPTION_KEY,
          ProjectId: campaingId,
          Authorization: `Bearer ${token}`
        }
      })
      return data
    } catch (error) {
      return false
    }
  },
  async GetUserOnboarding(login, email = '') {
    try {
      const {
        data: { data }
      } = await axios({
        url: `${process.env.RAZZLE_ONBOARDING_FIRST_ACCESS_URL}/v1/user?login=${login}&campaignId=${process.env.RAZZLE_CAMPAIGN_ID}&email=${email}`,
        method: 'GET'
      })
      return data;
    } catch (error) {
      return false
    }
  },
  async PostUserOnboarding(body) {
    try {
      const {
        data: { data }
      } = await axios({
        url: `${process.env.RAZZLE_ONBOARDING_FIRST_ACCESS_URL}/v1/user/register`,
        method: 'POST',
        data: { ...body, campaignId: process.env.RAZZLE_CAMPAIGN_ID }
      })
      return data;
    } catch (error) {
      return false
    }
  },
  async searchZipcode(zipcode) {
    try {
      const res = await axios({
        url: `https://viacep.com.br/ws/${zipcode}/json/`,
        method: 'GET'
      })

      if (res.data.erro) {
        return {
          district: "",
          city: "",
          address: "",
          state: ""
        }
      }

      return {
        district: res.data.bairro,
        city: res.data.localidade,
        address: res.data.logradouro,
        state: res.data.uf
      }
    } catch (error) {
      return {
        district: "",
        city: "",
        address: "",
        state: ""
      }
    }
  },
  async getCnpjData(cnpj) {
    try {
      const res = await axios({
        url: `https://premmiardocumentvalidationprd.azurewebsites.net/cnpj/${cnpj}`,
        method: 'GET'
      })
      let date = res.data.data.abertura.split('/')
      return {
        name: res.data.data.nome,
        birthdate: `${date[2]}-${date[1]}-${date[0]}`,
        district: res.data.data.bairro,
        city: res.data.data.municipio,
        address: res.data.data.logradouro,
        complement: res.data.data.complemento,
        zipcode: res.data.data.cep.replace(".", ""),
        number: res.data.data.numero,
        state: res.data.data.uf,
        activity: res.data.data.atividade_principal.length ? res.data.data.atividade_principal[0].text : '',
        activity_code: res.data.data.atividade_principal.length ? res.data.data.atividade_principal[0].code : ''
      }
    } catch (error) {
      console.log(error)
      return {
        name: "",
        birthdate: "",
        district: "",
        city: "",
        address: "",
        complement: "",
        zipcode: "",
        number: "",
        state: "",
        activity: "",
        activity_code: ""
      }
    }
  }
}
